import { SVGProps } from 'react';
const SvgMouse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 10V7M18 15V9A6 6 0 0 0 6 9v6a6 6 0 0 0 12 0Z"
    />
  </svg>
);
export default SvgMouse;
